import { render, staticRenderFns } from "./view-transaction.vue?vue&type=template&id=7206a96b&scoped=true"
import script from "./view-transaction.vue?vue&type=script&lang=js"
export * from "./view-transaction.vue?vue&type=script&lang=js"
import style0 from "./view-transaction.vue?vue&type=style&index=0&id=7206a96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206a96b",
  null
  
)

export default component.exports